export default function FormInput({...props}) {
  return (
    <div className='mb-4'>
      <fieldset className='border-none mb-2'>
        <label className='text-white/60 text-base w-full mb-1 block'>{props.labelText}</label>
        <input required className='input px-4 text-md ' {...props}/>
      </fieldset>
    </div>
  )
}
